import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiChevronDown } from 'react-icons/fi';

const AccordionItem = ({ title, children, isOpen, onToggle, index }) => (
  <div className="border-b border-[var(--color-border-default)] last:border-b-0">
    <button
      onClick={onToggle}
      className="flex items-center justify-between w-full py-4 px-1 text-left focus-ring group"
      aria-expanded={isOpen}
    >
      <span className="text-base font-semibold text-[var(--color-text-primary)] group-hover:text-brand-500 transition-colors">
        {title}
      </span>
      <motion.span
        animate={{ rotate: isOpen ? 180 : 0 }}
        transition={{ duration: 0.2 }}
      >
        <FiChevronDown className="w-5 h-5 text-[var(--color-text-muted)]" />
      </motion.span>
    </button>
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
          className="overflow-hidden"
        >
          <div className="pb-4 px-1 text-[var(--color-text-secondary)] leading-relaxed">
            {children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

const Accordion = ({ items, allowMultiple = false, className = '' }) => {
  const [openItems, setOpenItems] = useState(new Set());

  const toggleItem = (index) => {
    setOpenItems((prev) => {
      const next = new Set(allowMultiple ? prev : []);
      if (prev.has(index)) {
        next.delete(index);
      } else {
        next.add(index);
      }
      return next;
    });
  };

  return (
    <div className={`divide-y divide-[var(--color-border-default)] ${className}`}>
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          index={index}
          title={item.title || item.question}
          isOpen={openItems.has(index)}
          onToggle={() => toggleItem(index)}
        >
          {item.content || item.answer}
        </AccordionItem>
      ))}
    </div>
  );
};

export default Accordion;
